import type { PropsWithChildren } from "react";
import { Paper } from "@mui/material";
import { container, radius } from "@aeriosiq/ui";

/**
 * The centred login card. Reused by every state (idle, in-flight, alerts,
 * callback transitional). Card itself is presentational only — children
 * decide what's inside.
 *
 * Apple-clean marketing rhythm (CI_custom §10 step 5): wider container
 * (`container.prose` = 680 px, up from 480) so the display headline has
 * room to breathe, generous 48 px padding, 18 px Apple-signature card
 * radius, no elevation. The card floats on the Gray-White canvas via
 * tonal contrast (paper is `#FFFFFF`, canvas is `#F5F5F7`) — no shadow
 * needed, no border line.
 */
export function LoginCard({ children }: PropsWithChildren) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: container.prose,
        minHeight: 420,
        p: { xs: 4, md: 6 },
        display: "flex",
        flexDirection: "column",
        gap: 3,
        alignItems: "stretch",
        borderRadius: `${String(radius.lg)}px`,
      }}
    >
      {children}
    </Paper>
  );
}
